/**
 * One place for the recharts styling, so the two charts cannot drift apart.
 *
 * The series colours are brand-first: `invoice-processing` is the product's own teal because it
 * is the queue the product exists for, and the rest fan out into hues that stay distinguishable
 * next to it. The axis/grid/tooltip values are the same neutrals the rest of the app uses
 * (`gray-200`, `gray-500`, `gray-900`) rather than recharts' defaults, which are a different grey
 * ramp again.
 */

/** `primary-600`, `indigo-500`, `sky-500`, `amber-500`. */
export const THROUGHPUT_COLORS: Record<string, string> = {
  'invoice-processing': '#0d9488',
  'export-processing': '#6366f1',
  'webhook-processing': '#0ea5e9',
  'data-retention': '#f59e0b',
};

/**
 * Failure rates get their own ramp, all of it warm. A queue's throughput colour and its failure
 * colour must not be the same, or the two charts side by side read as one legend.
 */
export const FAILURE_COLORS: Record<string, string> = {
  'invoice-processing': '#dc2626',
  'export-processing': '#ea580c',
  'webhook-processing': '#d97706',
  'data-retention': '#db2777',
};

/** `gray-400` — the colour a queue added after this file was written falls back to. */
export const SERIES_FALLBACK = '#9ca3af';

/** `gray-200`. */
export const GRID_STROKE = '#e5e7eb';

/** `gray-500`, at the app's smallest readable size. */
export const AXIS_TICK = { fill: '#6b7280', fontSize: 11 } as const;

export const TOOLTIP_STYLE = {
  background: '#ffffff',
  border: '1px solid #e5e7eb',
  borderRadius: 8,
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.08)',
} as const;

/** `gray-900` for the label, `gray-600` for the values. */
export const TOOLTIP_LABEL_STYLE = {
  color: '#111827',
  fontWeight: 600,
} as const;
export const TOOLTIP_ITEM_STYLE = { color: '#4b5563' } as const;

export const LEGEND_STYLE = { fontSize: 12, color: '#6b7280' } as const;
